import { addToWindowRef, getFromWindowRef, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { createQuestionPanelId } from '@avantia/questionset-model';
import $ from 'jquery';
import { HpClientDebugFlags } from '../../clientDebugFlags';
import { logInfo } from '../../clientLogging';
import { HpQuestionScriptAction, HpScriptAction } from '../../types';

const handlers: SMap<VoidFunction> = {};

export function registerScriptActionHandler(action: string, handler: VoidFunction): void {
  handlers[action] = handler;
}

export function InvokeScriptActionsWidget({ scriptActions }: { scriptActions: HpScriptAction[] }): null {
  if (!scriptActions || scriptActions.length === 0) {
    return null;
  }

  const windowRefs = getFromWindowRef<HpInvokedScriptActions>(['invokedScriptActions']);
  if (!windowRefs) {
    return null;
  }

  const { invokedScriptActions: invokedActions, window } = windowRefs;
  let invokedScriptActions = invokedActions as SMap<boolean>;
  if (!invokedScriptActions) {
    invokedScriptActions = {};
    addToWindowRef({ invokedScriptActions });
  }

  lodash.forEach(scriptActions, (scriptAction) => {
    const { action, id } = scriptAction;
    let actionFunc: VoidFunction | undefined;
    switch (action) {
      case 'scroll-to-top': {
        actionFunc = (): void => {
          const questionContainer = $('#hp-questions-container');
          const questionContainerElement = questionContainer && questionContainer[0];
          if (questionContainerElement) {
            questionContainerElement.scrollIntoView();
          } else {
            window.scrollTo(0, 0);
          }
        };

        break;
      }

      case 'scroll-to-question': {
        const { questionId } = scriptAction as HpQuestionScriptAction;
        if (!questionId) {
          throw new Error(`Missing questionId for question script action '${action}' (${id})`);
        }

        actionFunc = (): void => {
          const questionPanelId = createQuestionPanelId(questionId);
          const el = document.getElementById(questionPanelId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          }
        };

        break;
      }

      default:
        actionFunc = handlers[action];
        break;
    }

    if (actionFunc) {
      setTimeout(() => {
        if (actionFunc) {
          if (!invokedScriptActions[id]) {
            invokedScriptActions[id] = true;
            logInfo(`Invoking script action '${action}' (${id})`, HpClientDebugFlags.ScriptActions);
            actionFunc();
          } else {
            logInfo(`Ignoring script action '${action}' (${id})`, HpClientDebugFlags.ScriptActions);
          }
        }
      }, 100);
    }
  });

  return null;
}

interface HpInvokedScriptActions {
  invokedScriptActions: SMap<true>;
}
